export default {
  getContent: (state) => (lang, pageId) => {
    return state.content[lang + '-' + pageId]
  },
  getMainConfig: (state) => () => state.mainConfig,
  getContentEngine: (state) => (view) => {
    return state.engine[view]
  }
}
